import Hero from "../components/Hero";
import Blogs from "../components/Blogs";
// import About from "../components/About";
import OurServices from "../components/OurServices";
import Subscribe from "../components/Subscribe";
import Partnerships from "../components/Partnerships";

const Home = () => {
  return (
    <div>
      <Hero />
      <Blogs />
      {/* <About /> */}
      <OurServices />
      <Subscribe />
      <Partnerships />
    </div>
  );
};

export default Home;
